.wrap {
  width: 100%;
}
.grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(450px, 1fr));
  gap: 32px;
}
.blogListPage {
  width: 90%;
  max-width: 1200px;
  margin: auto;
  background: #fffdf7;
  padding: 30px;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  gap: 30px;
}
.header {
  font-family: 'Onest', sans-serif;
  font-size: 16px;
  color: #505050;
  line-height: 1.5;
  margin: 0;
  padding: 0;
  text-align: center;

  /* Layout */
  width: 90%;
  max-width: 1300px;
  margin-left: auto;
  margin-right: auto;
}
.title {
  font-size: 2rem;
  font-weight: 400;
  margin-bottom: 8px;
  color: #505050;
}

.intro {
  font-size: 1rem;
  color: #505050;
  margin-bottom: 32px;
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
  font-weight: 200;
}

@media (max-width: 900px) {
  .grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    gap: 32px;
  }
}
